module.exports = __webpack_public_path__ + "static/media/swipping_dai_head.9118b273.png";